import DestinationTruncation from "./DestinationTruncation";

export const destinationTruncation = {
    init: (store) => {
        const synopsisTruncation = document.querySelectorAll(".global__hero-content-details > .sd-read-more-content");
        [...synopsisTruncation].forEach((el) => new DestinationTruncation(el, store));

        const descriptionTruncation = document.querySelectorAll(".sd-global__content.sd-spacer-pt-3.sd-spacer-pb-3.sd-trunc");
        [...descriptionTruncation].forEach((el) => new DestinationTruncation(el, store));
    },
};

export default destinationTruncation;